export default __webpack_public_path__ + "static/media/package_17.b73ce1c4.png";